import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "item recipe" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  src: "/assets/images/Placeholder.png"
}
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.result?.images?.previewImage)
        ? (_openBlock(), _createElementBlock("picture", _hoisted_3, [
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(280, 380),
              media: "(min-width: 1230px)"
            }, null, 8, _hoisted_4),
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(250, 330),
              media: "(min-width: 1050px)"
            }, null, 8, _hoisted_5),
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(290, 300),
              media: "(min-width: 450px)"
            }, null, 8, _hoisted_6),
            _createElementVNode("source", {
              srcset: _ctx.result?.images?.previewImage?.url.toCropUrl(195, 245),
              media: "(min-width: 0px)"
            }, null, 8, _hoisted_7),
            _createElementVNode("img", {
              src: _ctx.result?.images?.previewImage?.url.toCropUrl(280, 380),
              alt: _ctx.result?.images?.previewImage?.altText
            }, null, 8, _hoisted_8)
          ]))
        : (_openBlock(), _createElementBlock("img", _hoisted_9))
    ]),
    _createElementVNode("a", {
      href: _ctx.result.url
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.result?.pageTitle), 1)
    ], 8, _hoisted_10)
  ]))
}